import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MetaInfoDescription } from './MetaInfoDescription';
import { DateFormat } from '../../DateFormat';
import ILink from '../../../../types/ILink';
import { PersonLink } from './PersonLink';

export function PublicationDateMetaInfo({
  publicationDate,
  publishedBy,
}: {
  publicationDate: string;
  publishedBy?: ILink;
}) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <MetaInfoDescription term={t(`publication`)}>
      <p>
        {t('on')} <DateFormat date={publicationDate} />
        {publishedBy && (
          <>
            {' '}
            {t('from')} <PersonLink person={publishedBy} />
          </>
        )}
      </p>
    </MetaInfoDescription>
  );
}
